const getInitialChatMessage = ({
  providerName,
  isLocationAbroad,
}: {
  providerName: string
  isLocationAbroad: boolean
}) =>
  `Hello, thank you for using TimelyCare TalkNow. My name is ${providerName}, I am a TalkNow Provider. While TalkNow is not considered clinical therapy, there are limitations to confidentiality. If you or others are in danger, we may need to take action to ensure that you are safe. Additionally, if your provider suspects abuse of children, elderly, or disabled they are required to report their concerns to the appropriate protective services. If you believe you are experiencing a medical emergency, you should immediately call ${
    isLocationAbroad ? 'local emergency services' : '911'
  }. Do I have your consent to continue this conversation?`

export default getInitialChatMessage
